"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEBPAGE_PORT = exports.APP_PORT = exports.BACKGROUND_PORT = void 0;
exports.BACKGROUND_PORT = "background";
exports.APP_PORT = "popup";
exports.WEBPAGE_PORT = "webpage";
//# sourceMappingURL=constant.js.map